import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
@Component({
    selector: "app-jackpot-success",
    templateUrl: "./jackpot-success.component.html",
    styleUrls: ["./jackpot-success.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class JackpotSuccessComponent implements OnInit {
  constructor(
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<JackpotSuccessComponent>,
    public translate: TranslateService,
    private authService: AuthService
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );
  }

  ngOnInit() {}

  close() {
    this.matDialog.closeAll();
  }
}
